<template>
    <div
        class="root fixed inset-0 z-50 flex h-full flex-col overscroll-none bg-blue"
        :class="[isTransitioning ? 'overflow-hidden' : 'overflow-auto']"
        ref="quizRoot"
        style="opacity: 0; clip-path: circle(0% at 50% 50%)"
    >
        <nav class="w-full shrink-0">
            <div
                class="relative mx-auto flex h-16 max-w-[1400px] items-center justify-center px-8"
            >
                <a
                    :href="siteUrl"
                    class="flex h-full items-center"
                    target="_blank"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1079.21 99.03"
                        class="h-4 text-white"
                    >
                        <path
                            fill="currentColor"
                            d="m115.2,65.83h23.15c4.52,0,8.71-.94,12.45-2.79,3.7-1.83,6.92-4.3,9.55-7.36,2.6-3.02,4.66-6.52,6.1-10.38,1.44-3.86,2.17-7.94,2.17-12.13s-.78-8.04-2.32-11.9c-1.53-3.85-3.68-7.34-6.38-10.37-2.72-3.04-6.01-5.53-9.79-7.4-3.83-1.89-8.07-2.85-12.59-2.85h-41.34v97.68h18.98v-32.5Zm0-47.9h21.43c1.63,0,3.17.35,4.7,1.05,1.54.72,2.93,1.75,4.13,3.06,1.22,1.33,2.18,2.94,2.87,4.77.69,1.85,1.05,3.99,1.05,6.36s-.32,4.42-.94,6.3c-.63,1.87-1.49,3.52-2.56,4.9-1.03,1.33-2.28,2.37-3.7,3.1-1.4.72-2.99,1.08-4.75,1.08h-22.22v-30.63Z"
                        />
                        <path
                            fill="currentColor"
                            d="m275.09,4.37c-5.76-2.9-12.22-4.37-19.18-4.37s-13.13,1.38-18.87,4.09c-5.71,2.7-10.72,6.38-14.88,10.95-4.14,4.55-7.44,9.86-9.81,15.77-2.37,5.92-3.57,12.21-3.57,18.69s1.13,12.34,3.36,18.25c2.23,5.92,5.44,11.26,9.54,15.86,4.11,4.62,9.09,8.37,14.8,11.15,5.75,2.81,12.19,4.23,19.16,4.23s12.99-1.37,18.73-4.08c5.7-2.69,10.72-6.35,14.93-10.87,4.2-4.53,7.51-9.82,9.83-15.74,2.32-5.93,3.5-12.21,3.5-18.68,0-6.11-1.13-12.18-3.36-18.06-2.23-5.87-5.41-11.2-9.46-15.84-4.07-4.66-9.02-8.48-14.72-11.36Zm6.31,56.84c-1.23,3.77-3.06,7.23-5.44,10.27-2.35,3-5.25,5.44-8.62,7.27-3.31,1.79-7.2,2.7-11.56,2.7s-8.04-.87-11.4-2.59c-3.41-1.75-6.35-4.11-8.73-7.02-2.42-2.95-4.31-6.41-5.62-10.26-1.32-3.88-1.99-7.94-1.99-12.08s.65-7.92,1.93-11.76c1.27-3.82,3.12-7.26,5.5-10.2,2.35-2.92,5.27-5.33,8.69-7.16,3.36-1.8,7.27-2.71,11.63-2.71,4.11,0,7.88.87,11.2,2.59,3.37,1.75,6.29,4.09,8.69,6.97,2.42,2.91,4.3,6.32,5.61,10.12,1.32,3.85,1.99,7.93,1.99,12.14,0,3.97-.63,7.91-1.87,11.71Z"
                        />
                        <rect
                            fill="currentColor"
                            x="355.96"
                            y=".66"
                            width="18.98"
                            height="97.68"
                        />
                        <polygon
                            fill="currentColor"
                            points="445.81 .66 431.08 .66 431.08 98.34 450.07 98.34 450.07 36.44 499.83 98.34 515.21 98.34 515.21 .79 496.09 .79 496.09 64.07 445.81 .66"
                        />
                        <polygon
                            fill="currentColor"
                            points="562.74 17.93 593.93 17.93 593.93 98.34 613.04 98.34 613.04 17.93 644.1 17.93 644.1 .66 562.74 .66 562.74 17.93"
                        />
                        <polygon
                            fill="currentColor"
                            points="691.73 98.34 710.71 98.34 710.71 58.07 750.45 58.07 750.45 41.58 710.71 41.58 710.71 17.93 758.22 17.93 758.22 .66 691.73 .66 691.73 98.34"
                        />
                        <rect
                            fill="currentColor"
                            x="807.35"
                            y=".66"
                            width="18.99"
                            height="97.68"
                        />
                        <polygon
                            fill="currentColor"
                            points="918.87 71.62 892.19 .66 871.92 .66 910.59 97 911.13 98.34 926.63 98.34 965.7 .66 945.44 .66 918.87 71.62"
                        />
                        <polygon
                            fill="currentColor"
                            points="1030.26 81.06 1030.26 56.75 1071.97 56.75 1071.97 40.27 1030.26 40.27 1030.26 17.93 1078.42 17.93 1078.42 .66 1011.27 .66 1011.27 98.34 1079.61 98.34 1079.61 81.06 1030.26 81.06"
                        />
                        <path
                            fill="currentColor"
                            d="m22.35,1.72c-.34.58-1.48,2.29-2.6,3.25-1.56,1.35-3.4,2.72-5.47,4.07-2.07,1.35-4.25,2.55-6.47,3.56-2.06.93-3.83,1.4-5.29,1.4H.39v17.9h2.12c1.88,0,4.05-.36,6.44-1.08,2.32-.7,4.56-1.56,6.66-2.57,2.11-1.01,4.08-2.13,5.85-3.35.14-.09.27-.19.4-.28l.18,74.42h19.08V.68h-18.17s-.62,1.04-.62,1.04Z"
                        />
                    </svg>
                </a>
            </div>
        </nav>
        <transition name="bullets-fade" appear>
            <ProgressBar
                v-if="isQuestionContext"
                :current="currentQuestionNumber"
                :total="quiz.totalQuestions"
            />
        </transition>
        <main class="min-h-0 flex-1">
            <transition
                :name="transitionName"
                mode="out-in"
                @before-enter="isTransitioning = true"
                @after-enter="isTransitioning = false"
            >
                <FeedbackSlide
                    v-if="isFeedbackRoute"
                    :key="`fb-${feedbackId}`"
                    :question-id="feedbackId"
                />
                <SlideRenderer
                    v-else-if="current"
                    :key="current.route"
                    :slide="current"
                />
            </transition>

            <ModalHost />
            <div v-if="isScoreRoute" v-html="footerHtml" />
        </main>
        <NavControls
            :canBack="canBack"
            :canForward="canForward"
            :backHref="backHref"
            @back="goBack"
            @forward="goForward"
        />
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch, nextTick } from "vue";
import { gsap } from "gsap";

import SlideRenderer from "./components/SlideRenderer.vue";
import FeedbackSlide from "./slides/FeedbackSlide.vue";
import ModalHost from "./components/ModalHost.vue";
import ProgressBar from "./components/ProgressBar.vue";
import NavControls from "./components/NavControls.vue";

import { useQuizStore } from "./stores/quizStore";
import { useFormieStore } from "./stores/formieStore";
import { useAnalyticsStore } from "./stores/analyticsStore";
import { SLIDES } from "./content/slides";

import { useQuizUi } from "./composables/useQuizUi";
import { useSlidePreload } from "./composables/useSlidePreload";

const props = defineProps<{
    graphqlEndpoint?: string;
    graphqlToken?: string;
    siteUrl?: string;
    footerHtml?: string;
}>();

const quizRoot = ref<HTMLElement | null>(null);
const quiz = useQuizStore();
const formie = useFormieStore();
const analytics = useAnalyticsStore();

const {
    isFeedbackRoute,
    isScoreRoute,
    feedbackId,
    isQuestionContext,
    currentQuestionNumber,
    transitionName,
    canBack,
    canForward,
    backHref,
    goBack,
    goForward,
    route,
} = useQuizUi();
useSlidePreload();

const current = computed(() => quiz.currentSlide);

const isTransitioning = ref(false);

const skipIntroReveal = window.location.hash.startsWith("#/start");

onMounted(() => {
    formie.setConfig({
        endpoint: props.graphqlEndpoint || "/api",
        token: props.graphqlToken || "",
    });

    quiz.setSiteUrl(props.siteUrl || "");
    quiz.loadSlides(SLIDES);

    // route -> slide sync
    quiz.goToRoute(route.path);

    if (quizRoot.value) {
        // #/start deep-links straight to the welcome view with no intro reveal.
        // Read the hash directly: the router's initial navigation (and the
        // /start -> /welcome redirect) may not have resolved yet on mount.
        if (skipIntroReveal) {
            gsap.set(quizRoot.value, { opacity: 1, clipPath: "none" });
            quiz.setAppReady(true);
            return;
        }

        const tl = gsap.timeline({
            onComplete: () => {
                quiz.setAppReady(true);
                console.log("app ready");
            },
        });
        tl.to(quizRoot.value, {
            opacity: 1,
            ease: "power2.in",
            duration: 0.5,
        });
        tl.to(
            quizRoot.value,
            {
                clipPath: "circle(71% at 50% 50%)",
                duration: 0.6,
                ease: "power1.inOut",
            },
            "-=.3",
        );
    }
});

watch(
    () => route.fullPath,
    (path, previousPath) => {
        if (path === previousPath) return;
        if (path.includes("intro")) return;

        analytics.fire("quiz_step", {
            quiz_step_route: path,
            quiz_step_prev: previousPath,
        });
    },
);

watch(
    () => route.path,
    () => {
        if (route.name === "feedback") {
            const id = String(route.params.id || "");
            const q = quiz.getQuestionById(id);
            if (q) quiz.goToRoute(q.route);
            return;
        }
        quiz.goToRoute(route.path);
    },
    { immediate: true },
);
</script>

<style>
.bullets-fade-enter-active,
.bullets-fade-leave-active {
    transition: opacity 0.25s ease;
}
.bullets-fade-enter-from {
    opacity: 0;
}
.bullets-fade-leave-to {
    opacity: 0;
}

.quiz-fade-enter-active,
.quiz-fade-leave-active {
    transition: opacity 0.5s ease;
}
.quiz-fade-enter-from {
    opacity: 0;
}
.quiz-fade-leave-to {
    opacity: 0;
}
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: opacity 0.25s ease;
}
.root main .slide-fade-enter-active {
    overflow: hidden;
}
.slide-fade-enter-from {
    opacity: 0;
}
.slide-fade-leave-to {
    opacity: 0;
}
.feedback-fade-enter-active,
.feedback-fade-leave-active {
    transition: opacity 0.4s ease;
}
.feedback-fade-enter-from {
    opacity: 0;
}
.feedback-fade-leave-to {
    opacity: 0;
}

.intro-fade-enter-active {
    transition: opacity 0.5s ease;
}
.intro-fade-leave-active {
    transition: opacity 0.75s ease;
}
.intro-fade-enter-from {
    opacity: 0;
}
.intro-fade-leave-to {
    opacity: 0;
}
.text-body {
    color: #394354;
}
</style>
